import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "./Navbar";
import SanctuaryFab from "./Sanctuary/SanctuaryFab";
import MobileBottomNav from "./MobileBottomNav";
import ZenBackground from "./ZenBackground";
import ZenPageTransition from "./ZenPageTransition";
import { AnimatePresence } from "framer-motion";

// Page variants moved to ZenPageTransition component

export default function Layout() {
  const location = useLocation();
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("theme") === "dark"
  );

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  return (
    <div className="min-h-[100dvh] flex flex-col bg-white dark:bg-gray-900 text-gray-800 dark:text-white transition-all duration-[1800ms] ease-in-out">
      {/* Global Navbar - Hide on specific strict flows */}
      {!location.pathname.includes("/verify-pending") && <Navbar />}

      {/* Atmospheric Background */}
      <ZenBackground />

      {/* Routed Pages with active min-w-0 for flex calculation safety */}
      <main className="flex-1 relative min-w-0 overflow-x-hidden">
        <AnimatePresence mode="wait">
          <ZenPageTransition key={location.pathname}>
            <Outlet />
          </ZenPageTransition>
        </AnimatePresence>
      </main>
      
      {/* Native App Feeling Bottom Navigation */}
      <MobileBottomNav />

      {/* Global FAB */}
      <SanctuaryFab />
    </div>
  );
}
